import React, { useState, useEffect } from "react";
import Sidebar from "../../Components/Sidebar";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useNavigate } from "react-router-dom";
import { TbSchool, TbPuzzle2, TbPlus } from "react-icons/tb";
import { FiUpload } from "react-icons/fi";
import { HiOutlinePlusCircle } from "react-icons/hi";
import { fetchDepartments } from "../../redux/actions/departmentActions";
import { useSelector, useDispatch } from "react-redux";
import { addDegree } from "../../redux/actions/degreeActions"; // Ensure correct import path
import Page from "../../Components/Page"; // Ensure correct import path
import PageComponent from "../../Components/PageComponent";

function AddDegree() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const departments = useSelector((state) => state.department.department.data) || [];
    //const degreeTypes = useSelector((state) => state.degree.degrees.data) || [];

    const modules = {
        toolbar: [
            [{ header: [1, 2, 3, false] }], // Heading styles
            [{ font: [] }], // Font selection
            [{ list: "ordered" }, { list: "bullet" }], // Ordered (numbered) and unordered (bullet) lists
            ["bold", "italic", "underline"], // Font styles
            [{ align: [] }], // Alignment options
            ["clean"], // Clear formatting
        ],
    };

    const formats = [
        "font",
        "header",
        "list", // Include list format
        "bold",
        "italic",
        "underline",
        "align",

    ];

    const [formData, setFormData] = useState({
        name: "",
        department: "",
        university: "",
        recognizedBy: "",
        approvedBy: "",
        type: "",
        mediumOfInstructions: "",
        exemptions: "",
        description: "",
        eligibilityCriteria: "",
        admissionCriteria: "",
        investment: "",
        file: null,
        files: null
    });

    useEffect(() => {
        //dispatch(fetchDegrees());
        dispatch(fetchDepartments());

    }, [dispatch]);

    const [uploadedDocuments, setUploadedDocuments] = useState([
        { id: 1, file: null },
    ]);


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleImageUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            // Set the file as the full File object for preview, but only send the name in FormData
            const reader = new FileReader();
            reader.onloadend = () => {
                setFormData({ ...formData, file, imagePreview: reader.result });
            };
            reader.readAsDataURL(file);
        }
    };
    const handleQuillChange = (field, content) => {
        setFormData((prevData) => ({ ...prevData, [field]: content }));
    };
    ;

    // Handle file selection for a specific document field
    const handleFileChange = (id, file) => {
        setUploadedDocuments((prev) =>
            prev.map((doc) =>
                doc.id === id ? { ...doc, file, fileName: file.name } : doc
            )
        );
    };

    // Add a new empty document upload field
    const addNewDocumentField = () => {
        setUploadedDocuments((prev) => [
            ...prev,
            { id: prev.length + 1, file: null },
        ]);
    };

    // Remove a specific document field
    const handleRemoveField = (id) => {
        setUploadedDocuments((prev) => prev.filter((doc) => doc.id !== id));
    };

    const stripHtml = (html) => {
        const div = document.createElement("div");
        div.innerHTML = html;
        return div.textContent || div.innerText || "";
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        // Strip HTML and validate rich text fields
        const plainDescription = stripHtml(formData.description);
        const plainEligibilityCriteria = stripHtml(formData.eligibilityCriteria);
        const plainAdmissionCriteria = stripHtml(formData.admissionCriteria);
        const plainInvestment = stripHtml(formData.investment);

        // Validate required fields
        if (!formData.department) {
            alert("Please select a department.");
            return;
        }
        if (!formData.name.trim()) {
            alert("Program name is required.");
            return;
        }
        if (!formData.university.trim()) {
            alert("Offering university is required.");
            return;
        }
        if (!formData.recognizedBy.trim()) {
            alert("Recognized by field is required.");
            return;
        }
        if (!formData.approvedBy.trim()) {
            alert("Approved by field is required.");
            return;
        }
        if (!formData.type.trim()) {
            alert("Degree type is required.");
            return;
        }
        if (!plainDescription.trim()) {
            alert("Description is required.");
            return;
        }
        if (!plainEligibilityCriteria.trim()) {
            alert("Eligibility criteria is required.");
            return;
        }
        // if (!plainAdmissionCriteria.trim()) {
        //     alert("Admission criteria is required.");
        //     return;
        // }
        if (!plainInvestment.trim()) {
            alert("Investment details are required.");
            return;
        }
        // if (!formData.mediumOfInstructions.trim()) {
        //     alert("Medium Of Instructions field is required.");
        //     return;
        // }
        // if (!formData.exemptions.trim()) {
        //     alert("Exemptions is required.");
        //     return;
        // }

        // if (!formData.file) {
        //     alert("An image is required.");
        //     return;
        // }

        const formDataToSend = new FormData();
        formDataToSend.append("department_id", formData.department);
        formDataToSend.append("program_name", formData.name);
        formDataToSend.append("offering_university", formData.university);
        formDataToSend.append("recognized_by", formData.recognizedBy);
        formDataToSend.append("approved_by", formData.approvedBy);
        formDataToSend.append("degree_type", formData.type);
        formDataToSend.append("description", formData.description);
        formDataToSend.append("eligibity_criteria", formData.eligibilityCriteria);
        formDataToSend.append("medium", formData.mediumOfInstructions);
        formDataToSend.append("admission_criteria", formData.admissionCriteria);
        formDataToSend.append("investment", formData.investment);
        formDataToSend.append("exemptions", formData.exemptions);
        formDataToSend.append("file", formData.file);

        uploadedDocuments.forEach((doc) => {
            if (doc.file) {
                formDataToSend.append("files", doc.file); // All files under the same key
            }
        });
        console.log("test", formDataToSend)

        try {
            console.log("Submitting form data...");

            //DEBUGGING: Inspect the FormData object
            for (const pair of formDataToSend.entries()) {
                console.log(pair[0] + ', ' + pair[1]);
            }

            await dispatch(
                addDegree(formDataToSend)
            );

            // alert("Degree added successfully!");
            // window.location.reload(); // Reload the page after success
        } catch (error) {
            console.error("Error adding degree:", error);
            alert("Failed to add degree. Please try again.");
        }
    };




    return (
        <>
            <PageComponent>
                <div className="flex w-screen h-screen overflow-x-hidden bg-[#F8F7FA]">
                    <div className="fixed top-0 left-0 w-64 h-full overflow-y-auto bg-white shadow-md">
                        <Sidebar />
                    </div>
                    <div className="flex-1 p-6 ml-64">
                        {/* Page Title */}
                        <div className="flex items-center space-x-2 text-3xl text-gray-500">
                            <span>Academics & International</span>
                            <span>/</span>
                            <span className="text-black">Degree Management</span>
                        </div>

                        {/* Buttons */}
                        <div className="flex items-center mt-4 space-x-4">
                            <button
                                className="flex items-center px-4 py-2 text-white bg-[#92288C] rounded-lg shadow hover:bg-[#6C0B67]"
                                onClick={() => navigate("/academics&international/degreeManagement/addDegree")}
                            >
                                <TbSchool className="mr-2" />
                                Add Degree Program
                            </button>
                            <button
                                className="flex items-center px-4 py-2 text-[#A8AAAE] rounded-lg shadow hover:bg-gray-100"
                                onClick={() => navigate("/academics&international/degreeManagement/allDegree")}
                            >
                                <TbPuzzle2 className="mr-2" />
                                All Degree
                            </button>

                        </div>

                        {/* Add/Edit Staff Form */}
                        <div className="p-6 mt-6 bg-white rounded-lg shadow-md">
                            <h2 className="mb-4 text-xl font-semibold text-gray-700">Add New Degree Program</h2>
                            <form onSubmit={handleSubmit}>
                                <div className="grid grid-cols-2 gap-4">
                                    <div>
                                        <label className="block mb-1 text-sm font-medium text-gray-600" htmlFor="department">
                                            Select Department
                                        </label>
                                        <select
                                            id="department"
                                            name="department"
                                            value={formData.department}
                                            onChange={handleInputChange}
                                            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                                        >
                                            <option value="" disabled>
                                                Select a Department
                                            </option>

                                            {departments.map((dept) => (
                                                <option key={dept.id} value={dept.id}>
                                                    {dept.department_name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div>
                                        <label className="block mb-1 text-sm font-medium text-gray-600" htmlFor="name">
                                            Program Name
                                        </label>
                                        <input
                                            id="name"
                                            name="name"
                                            type="text"
                                            value={formData.name}
                                            onChange={handleInputChange}
                                            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                                        />
                                    </div>
                                    <div>
                                        <label className="block mb-1 text-sm font-medium text-gray-600" htmlFor="designation">
                                            Offering University
                                        </label>
                                        <input
                                            id="university"
                                            name="university"
                                            type="text"
                                            value={formData.university}
                                            onChange={handleInputChange}
                                            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                                        />
                                    </div>
                                    <div>
                                        <label className="block mb-1 text-sm font-medium text-gray-600" htmlFor="recognizedBy">
                                            Recognized by
                                        </label>
                                        <input
                                            id="recognizedBy"
                                            name="recognizedBy"
                                            type="text"
                                            value={formData.recognizedBy}
                                            onChange={handleInputChange}
                                            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                                        />
                                    </div>
                                    <div>
                                        <label className="block mb-1 text-sm font-medium text-gray-600" htmlFor="approvedBy">
                                            Approved by
                                        </label>
                                        <input
                                            id="approvedBy"
                                            name="approvedBy"
                                            type="text"
                                            value={formData.approvedBy}
                                            onChange={handleInputChange}
                                            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                                        />
                                    </div>
                                    <div>
                                        <label className="block mb-1 text-sm font-medium text-gray-600" htmlFor="type">
                                            Type
                                        </label>
                                        <select
                                            id="type"
                                            name="type"
                                            value={formData.type}
                                            onChange={handleInputChange}
                                            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                                        >
                                            <option value="" disabled>
                                                Select a Type
                                            </option>
                                            <option value="General" >General</option>
                                            <option value="Honours" >Honours</option>

                                        </select>
                                    </div>
                                </div>
                                <div className="mt-6">
                                    <label className="block mb-1 text-gray-700">Description</label>
                                    <ReactQuill
                                        id="description"
                                        value={formData.description}
                                        onChange={(content) => handleQuillChange("description", content)}
                                        theme="snow"
                                        modules={modules}
                                        formats={formats}
                                        className="h-[150px] mb-1"
                                    />
                                </div>
                                <div>
                                    <label className="block mt-12 mb-1 text-gray-700">Eligibility Criteria</label>
                                    <ReactQuill
                                        id="eligibilityCriteria"
                                        value={formData.eligibilityCriteria}
                                        onChange={(content) => handleQuillChange("eligibilityCriteria", content)}
                                        theme="snow"
                                        modules={modules}
                                        formats={formats}
                                        className="h-[150px]"
                                    />
                                </div>
                                {/* <div>
                                    <label className="block mt-12 mb-1 text-gray-700">Admission Criteria</label>
                                    <ReactQuill
                                        id="admissionCriteria"
                                        value={formData.admissionCriteria}
                                        onChange={(content) => handleQuillChange("admissionCriteria", content)}
                                        theme="snow"
                                        modules={modules}
                                        formats={formats}
                                        className="h-[150px]"
                                    />
                                </div> */}
                                <div>
                                    <label className="block mt-12 mb-1 text-gray-700">Investment</label>
                                    <ReactQuill
                                        id="investment"
                                        value={formData.investment}
                                        onChange={(content) => handleQuillChange("investment", content)}
                                        theme="snow"
                                        modules={modules}
                                        formats={formats}
                                        className="h-[150px]"
                                    />
                                </div>
                                {/* <div className="grid grid-cols-2 gap-4 mt-12">
                                    <div >
                                        <label className="block mb-1 text-sm font-medium text-gray-600" htmlFor="mediumOfInstructions">
                                            Medium of instructions
                                        </label>
                                        <input
                                            id="mediumOfInstructions"
                                            name="mediumOfInstructions"
                                            type="text"
                                            value={formData.mediumOfInstructions}
                                            onChange={handleInputChange}
                                            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                                        />
                                    </div> */}
                                    {/* <div>
                                        <label className="block mb-1 text-sm font-medium text-gray-600" htmlFor="exemptions">
                                            Exemptions
                                        </label>
                                        <input
                                            id="exemptions"
                                            name="exemptions"
                                            type="text"
                                            value={formData.exemptions}
                                            onChange={handleInputChange}
                                            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                                        />
                                    </div> */}
                                {/* </div> */}

                                <div className="grid grid-cols-3 gap-4 mt-6 mb-4">
                                <div >
                                        <label className="block mt-6 mb-1 text-sm font-medium text-gray-600" htmlFor="mediumOfInstructions">
                                            Medium of instructions
                                        </label>
                                        <input
                                            id="mediumOfInstructions"
                                            name="mediumOfInstructions"
                                            type="text"
                                            value={formData.mediumOfInstructions}
                                            onChange={handleInputChange}
                                            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                                        />
                                    </div>
                                    {/* Image Upload Section */}
                                    {/* <div className="flex flex-col items-center justify-center w-full h-[225px] p-5 border border-gray-300 border-dashed rounded-md">
                                        <label className="relative flex flex-col items-center justify-center w-full h-full cursor-pointer">
                                            <input
                                                type="file"
                                                name="file"
                                                accept="image/*"
                                                className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                                                onChange={handleImageUpload}
                                            />
                                            {formData.imagePreview ? (
                                                <div className="w-full h-full">
                                                    <img
                                                        src={formData.imagePreview}
                                                        alt="Uploaded Preview"
                                                        className="object-contain w-full h-full rounded-md"
                                                    />
                                                </div>
                                            ) : (
                                                <>
                                                    <FiUpload className="w-10 h-10 p-2 mb-3 text-gray-400 bg-gray-100 border-none rounded-md" />
                                                    <p className="text-black">Drag and drop image here</p>
                                                    <p className="text-sm text-center text-gray-400">
                                                        Any size of image, will automatically adjust to the frame
                                                    </p>
                                                    <button
                                                        type="button"
                                                        className="px-4 py-2 mt-2 text-[#92288C] font-semibold bg-[#92288C] bg-opacity-10 rounded-md"
                                                    >
                                                        Browse Image
                                                    </button>
                                                </>
                                            )}
                                        </label>
                                    </div> */}


                                    {/* Document Upload Section */}
                                    <div className="col-span-2 mt-6">

                                        <label className="block mb-1 text-sm font-medium text-gray-600">
                                            Upload Documents
                                        </label>
                                        {uploadedDocuments.map((doc, index) => (
                                            <div key={doc.id} className="mb-4">
                                                <div className="flex items-center space-x-4">
                                                    {/* Display file name */}
                                                    <input
                                                        type="text"
                                                        value={doc.fileName || ""}
                                                        readOnly
                                                        placeholder="No file chosen"
                                                        className="w-2/3 px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                                                    />
                                                    {/* File Upload Button */}
                                                    <label
                                                        htmlFor={`upload-doc-${doc.id}`}
                                                        className="px-4 py-2 font-semibold border rounded-md cursor-pointer text-secondary-2-color border-secondary-2-color bg-opacity-10"
                                                    >
                                                        Browse Doc
                                                    </label>
                                                    <input
                                                        type="file"
                                                        id={`upload-doc-${doc.id}`}
                                                        accept=".pdf, .docx"
                                                        className="hidden"
                                                        onChange={(e) => handleFileChange(doc.id, e.target.files[0])}
                                                    />
                                                    {/* Remove Document Button */}
                                                    {uploadedDocuments.length > 1 && (
                                                        <button
                                                            type="button"
                                                            onClick={() => handleRemoveField(doc.id)}
                                                            className="text-sm text-red-600 hover:underline"
                                                        >
                                                            Remove
                                                        </button>
                                                    )}
                                                </div>
                                                <div className="flex items-center justify-between mt-2">
                                                    <p className="text-sm text-gray-400">Accept: .pdf, .docx</p>
                                                    {index === uploadedDocuments.length - 1 && (
                                                        <button
                                                            type="button"
                                                            className="flex items-center px-4 py-2 text-primary-color"
                                                            onClick={addNewDocumentField}
                                                        >
                                                            <HiOutlinePlusCircle className="mr-2" /> Add More
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        ))}

                                    </div>
                                </div>

                                <div className="flex justify-end">
                                    <button
                                        type="submit"
                                        className="px-6 py-2 text-white bg-[#92288C] rounded-md hover:bg-[#6C0B67]"
                                    >
                                        Add
                                    </button>
                                </div>


                            </form>
                        </div>

                    </div>
                </div>
            </PageComponent>
        </>
    );
}

export default AddDegree;